export const INPUT_WITH_BOTTOM_BUTTON_PAGE = [
    `plan/user-info`,
    `plan/ins-info`,
    `plan/get-proposal`,
    'plan/accident',
    'plan/senior',
    `myPage/oneOnOne`,
    `myPage/deleteAccount`,
    `chat/room`,
    'planner/',
];

export const _isInputPageWithBottomButton = () => {
    if (typeof window !== 'undefined') {
        const currUrl = document.location.href;

        const isInputPageWithBottomButton =
            INPUT_WITH_BOTTOM_BUTTON_PAGE.filter(url => currUrl.includes(url)).length > 0;

        if (isInputPageWithBottomButton) {
            document.getElementById('top_main_layout')?.scrollTo(0, 0);
            return true;
        }
        return false;
    }
    return false;
};
